// Fire-and-forget logger for Sureline "Get Funded Now" clicks.
// Never await — the link must open immediately on the same event tick.
import { supabase } from "@/integrations/supabase/client";
import type { User } from "@supabase/supabase-js";

interface LogArgs {
  user: User | null;
  profile: {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
  } | null;
  source: "marketplace" | "lr_direct";
  loadId?: string | null;
}

export function logSurelineClick({ user, profile, source, loadId }: LogArgs): void {
  // Run entirely in the background; swallow all errors.
  (async () => {
    try {
      let phone: string | null = null;
      let company: string | null = null;

      if (user?.id) {
        // Best-effort phone from profiles
        const { data: p } = await supabase
          .from("profiles")
          .select("phone")
          .eq("id", user.id)
          .maybeSingle();
        phone = (p as any)?.phone ?? null;

        // Best-effort active company name
        const { data: cu } = await supabase
          .from("company_users")
          .select("companies(name)")
          .eq("user_id", user.id)
          .eq("is_active", true)
          .limit(1)
          .maybeSingle();
        company = ((cu as any)?.companies?.name as string | undefined) ?? null;
      }

      const fullName =
        [profile?.first_name, profile?.last_name]
          .filter((x) => x && String(x).trim())
          .join(" ")
          .trim() || null;

      await supabase.from("sureline_click_logs").insert({
        user_id: user?.id ?? null,
        name: fullName,
        email: profile?.email ?? user?.email ?? null,
        phone,
        company,
        source,
        load_id: loadId ?? null,
      });
    } catch (err) {
      console.warn("[logSurelineClick] failed (ignored):", err);
    }
  })();
}
